var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReferee = function SvgReferee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.137 21.673",
    fill: "#b6bbcc"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-7.83 5.639) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-38-whistle",
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "whistle",
    d: "M7.571,15.328A4.8,4.8,0,0,1,12.2,11.8H13v1.6h2.4V11.8h8v2.4L16.9,15.595h0a4.8,4.8,0,0,1-9.325,2.278,1.6,1.6,0,1,1,0-2.545ZM6.6,15.8a.8.8,0,1,0,.8.8.8.8,0,0,0-.8-.8ZM13.8,7v3.2h.8V7Zm4.1.817-1.7,2.714.678.424,1.7-2.714L17.9,7.817Zm-7.418,0,1.7,2.714-.678.424L9.8,8.241l.678-.424Z",
    transform: "translate(-5 -7)",
    fillRule: "evenodd",
    stroke: "none"
  })))));
};
export default SvgReferee;